import { useState } from "react";
import Sign from "../../models/Sign";
import SignModal from "../SignModal/SignModal";
import { Loading } from "../Misc/Loading";
import { practiceSign } from "../../services/api";
import { ErrorView } from "../Misc/ErrorView";
import { useLearntCount, usePracticeSign } from "../../hooks/useALSE";
import HasPermission from "../../claims/SessionClaims";
import { min_learnt_signs, teacher_permission } from "../../config";
import './Practice.css';
import { useAppContext } from "../../utils/AppContext";
import { Link } from "react-router-dom";
import CookiesModal from "../CookiesModal/CookiesModal";

export default function Practice() {
    // Permissions
    const has_teacher_permission = HasPermission(teacher_permission);

    // Practice
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<Error | undefined>(undefined);
    const [signRefresh, setSignRefresh] = useState<number>(0);
    const { data: sign, loading: loadingSign, error: errorSign, setData: setSign } = usePracticeSign([signRefresh]);
    const { data: learntCount, loading: learntCountLoading} = useLearntCount([]);
    const { setStreakUpdated } = useAppContext();

    const handlePractice = async (sign_id: number, result: number) => {
        setIsLoading(true);
        try{
            const newSign = await practiceSign(sign_id, result);
            if (!newSign){
                setError(Error('Unknown error occurred'));
            } else {
                setSign(newSign);
                setIsLoading(false);
                if (newSign.increased)
                    setStreakUpdated(newSign.increased);
            }
        } catch (error: any){
            setError(error instanceof Error ? error : Error('Unknown error occurred'));
        }
    }

    // Sign modal
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [modalData, setModalData] = useState<Sign | null>(null);

    const handleOpenModal = (data: Sign) => {
        setModalData(data);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setModalData(null);
    };

    // Errors and loading
    if (isLoading || loadingSign || learntCountLoading)
        return <Loading />
    if (learntCount !== null && learntCount < min_learnt_signs)
        return <div className="component-container">
            <div>Añade al menos {min_learnt_signs} signos a <Link to="/buscar">favoritos</Link> antes de empezara practicar!<CookiesModal/></div>
        </div>
    if (error)
        return <ErrorView error={error} />
    if (errorSign)
        return <ErrorView error={Error(errorSign)} />
    if (sign === null)
        return <Loading />

    return <div className="component-container">
        <div className="sign-search">
            <h2>¿Recuerdas cómo se signa "{sign.name}"?</h2>
            <div className="button-container">
                <button className='btn ok' onClick={() => handlePractice(sign.sign_id, 1)}>Lo recuerdo bien 🤙</button>
                <button className='btn info' onClick={() => handleOpenModal(sign)}>Lo voy a comprobar por si acaso 👀</button>
                <button className='btn error' onClick={() => handlePractice(sign.sign_id, -1)}>No lo recuerdo 🫤</button>
                {
                    has_teacher_permission &&
                    <button className="btn" onClick={() => setSignRefresh(signRefresh+1)}>🔄️</button>
                }
            </div>
            <SignModal isOpen={isModalOpen} onClose={handleCloseModal} sign={modalData} onSingLearnChanged={() => setSignRefresh(signRefresh+1)}/>
            <CookiesModal/>
        </div>
    </div>
}